const branches = [
  ["M150 268V30", 420],
  ["M150 132L106 88", 660],
  ["M150 158L194 114V88", 710],
  ["M150 178H121Q106 178 106 163V146Q106 137 99 130L55 86", 760],
  ["M150 210L195 165Q204 156 204 143V132Q204 123 211 116L245 82", 810],
  ["M128 266V231Q128 217 115 213L94 207Q85 204 79 197L55 169", 860],
  ["M128 266Q94 261 72 242", 960],
  ["M172 266V244Q172 232 181 223L210 194Q219 185 222 173L245 163", 910],
  ["M172 266Q206 261 228 242", 1010],
];
const nodes = [
  [150, 30, 900], [106, 88, 1130], [194, 88, 1180],
  [55, 86, 1230], [245, 82, 1280], [55, 169, 1330],
  [72, 242, 1430], [245, 163, 1380], [228, 242, 1480],
];
const arcs = [
  "M119 29A121 121 0 0 0 66 62",
  "M31 112A121 121 0 0 0 50 228",
  "M181 29A121 121 0 0 1 234 62",
  "M269 112A121 121 0 0 1 250 228",
];

export default function AnimatedTreeIcon({ colorRing = false }) {
  return <svg className="mg-brand-tree" viewBox="0 0 300 288" aria-hidden="true" focusable="false">
    <g fill="none" stroke="currentColor" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round">
      {branches.map(([d, delay]) => <path key={d} d={d} pathLength="1"
        className="mg-tree-trace" style={{ "--tree-delay": `${delay}ms` }} />)}
      {arcs.map((d, index) => <path key={d} d={d} pathLength="1"
        stroke={colorRing ? ["#e9e0d5", "#f4564d", "#e9e0d5", "#45e4f5"][index] : undefined}
        className="mg-tree-trace" style={{ "--tree-delay": `${1100 + index * 45}ms` }} />)}
    </g>
    <g fill="currentColor">
      {nodes.map(([cx, cy, delay]) => <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="16"
        className="mg-tree-node" style={{ "--tree-delay": `${delay}ms` }} />)}
    </g>
  </svg>;
}
